import { ApiRequest } from '../../api/request';

export class AdminService extends ApiRequest {
  constructor($http, $q, appConfig, User) {
    'ngInject';
    super({ $http, $q, appConfig, User });
  }

  findById(userId) {
    return this.$http({
      method: 'GET',
      url: `${this.api}/admin/users/${userId}`,
    });
  }

  getUsers(q = '', offset = 0, pageSize = 5) {
    const params = {
      offset,
      pageSize,
      q,
    };

    return this.$http({
      method: 'GET',
      url: `${this.api}/admin/users`,
      params,
    });
  }

  getRoles() {
    return this.$http({
      method: 'GET',
      url: `${this.api}/admin/users/roles`,
    });
  }

  createUser(user) {
    return this.$http({
      method: 'POST',
      data: user,
      url: `${this.api}/admin/users`,
      error: {
        silent: true,
      },
    });
  }

  updateUser(user) {
    return this.$http({
      method: 'PUT',
      data: user,
      url: `${this.api}/admin/users/${user._id}`,
      error: {
        silent: true,
      },
    });
  }

  deleteUser(user) {
    return this.$http({
      method: 'DELETE',
      url: `${this.api}/admin/users/${user._id}`,
    });
  }

  resetPassword(user) {
    return this.$http({
      method: 'POST',
      url: `${this.api}/admin/users/${user._id}/resetPassword`,
      error: {
        silent: true,
      },
    });
  }

  resetPasswordByEmail(user) {
    return this.$http({
      method: 'POST',
      url: `${this.api}/admin/users/${user._id}/sendPassword`,
      error: {
        silent: true,
      },
    });
  }

  exportAllUsers() {
    return this.$http({
      method: 'GET',
      url: `${this.api}/admin/users/exportAllAsCsv`,
      responseType: 'arraybuffer',
    });
  }
}
